export default __webpack_public_path__ + "static/media/questions.341e7447.svg";